/*
 * Image loading spinner — adds 'is-loaded' class to containers
 * once all their <img> children have finished loading.
 *
 * Works for both initial page load and dynamically inserted cards
 * (e.g. load-more pagination).
 *
 * Targets:
 *   .product-img  (product cards)
 *   .gallery-item (PDP gallery)
 */
(function () {
  function watchContainer(box) {
    if (box.dataset.spinnerBound) return;
    box.dataset.spinnerBound = '1';

    /* For room mockups, only wait on the main room-bg image — the small
       frame/art overlays are lazy-loaded and would deadlock behind the
       spinner overlay that blocks their viewport intersection. */
    var imgs = box.classList.contains('gallery-room')
      ? box.querySelectorAll('img.room-bg')
      : box.querySelectorAll('img');
    if (!imgs.length) { box.classList.add('is-loaded'); return; }

    var loaded = 0;
    var total = imgs.length;
    var allComplete = true;

    function done() {
      if (++loaded >= total) box.classList.add('is-loaded');
    }

    imgs.forEach(function (img) {
      if (img.complete) done();
      else {
        allComplete = false;
        img.addEventListener('load', done);
        img.addEventListener('error', done);
      }
    });

    /* Only reveal the spinner if images are STILL loading a moment from now.
       `img.complete` is a sound test for markup that arrived in the initial
       HTML, but an <img> parsed out of innerHTML reports complete === false
       even when its bytes are already cached — it has not had the chance to
       decode yet. Asking synchronously therefore raises the spinner on
       precisely the case this is meant to skip: content swapped in over
       cached images, where it flashes and is gone again a few frames later.

       The PDP material switch hits this every time, because both materials
       share the same frame overlays. Ask again once the cache has had a beat
       to answer; a genuinely slow image still gets its spinner, just without
       the false positive in front of it. */
    if (!allComplete) {
      setTimeout(function () {
        if (box.classList.contains('is-loaded')) return;
        var spinner = box.querySelector('.gallery-item__spinner, .product-img__spinner');
        if (spinner) spinner.classList.add('is-waiting');
      }, 150);
    }
  }

  function scanAll() {
    document.querySelectorAll('.product-img, .gallery-item').forEach(watchContainer);
  }

  /* Initial scan */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanAll);
  } else {
    scanAll();
  }

  /* Watch for dynamically added cards (load-more, AJAX) */
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.classList.contains('product-img') || node.classList.contains('gallery-item')) {
          watchContainer(node);
        }
        var children = node.querySelectorAll ? node.querySelectorAll('.product-img, .gallery-item') : [];
        children.forEach(watchContainer);
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
